import { render, staticRenderFns } from "./ItemManufacturer.vue?vue&type=template&id=b140e444&"
import script from "./ItemManufacturer.vue?vue&type=script&lang=js&"
export * from "./ItemManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b140e444')) {
      api.createRecord('b140e444', component.options)
    } else {
      api.reload('b140e444', component.options)
    }
    module.hot.accept("./ItemManufacturer.vue?vue&type=template&id=b140e444&", function () {
      api.rerender('b140e444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemManufacturer.vue"
export default component.exports